import React, { Children } from 'react';
import { useInView } from 'react-intersection-observer';
import { MicroscopeIcon, CheckCircleIcon, ClipboardCheckIcon } from 'lucide-react';
export const ResearchApproach = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <section id="research" className="py-20 bg-gray-50" data-id="element-1675" data-mp="30w4npjftu0yw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1676" data-mp="30tihbn4o9ri9">
        <div className="text-center mb-16" data-id="element-1677" data-mp="238w11l43alvb">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1678" data-mp="23600dp0uxj36">
            Our Research Approach
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-1679" data-mp="2d5h440wjtmwi"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1680" data-mp="2d45zxzz6yd4v">
            We apply pharmaceutical-grade research methodologies to evaluate
            wellness products and supplements
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1681" data-mp="1pgg14t6hj3ym">
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1682" data-mp="1pelgzh31ffvl">
            <div className="text-blue-600 mb-4" data-id="element-1683" data-mp="38u8jp7w0aazd">
              <MicroscopeIcon size={48} data-id="element-1684" data-mp="33st0llde2ejm" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-1685" data-mp="33vf7disggq0s">
              Rigorous Testing
            </h3>
            <p className="text-gray-700" data-id="element-1686" data-mp="2u3j5rxr5uhrt">
              We employ advanced laboratory techniques and clinical
              methodologies to evaluate the efficacy, safety, and
              bioavailability of microbiome-targeted products.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1687" data-mp="2l4o32vnbrpt9">
            <div className="text-blue-600 mb-4" data-id="element-1688" data-mp="2g5bd4215q2mg">
              <CheckCircleIcon size={48} data-id="element-1689" data-mp="2b5go640xzn41" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-1690" data-mp="ec56mc3fo0p9">
              Evidence-Based Certification
            </h3>
            <p className="text-gray-700" data-id="element-1691" data-mp="9csebbtsm1fa">
              Our Ukweli Certified™ program provides a three-tier evidence seal
              that clearly communicates the scientific backing behind each
              evaluated product.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-1692" data-mp="1tv30ldal47l7">
            <div className="text-blue-600 mb-4" data-id="element-1693" data-mp="1ytweh6tsa0lw">
              <ClipboardCheckIcon size={48} data-id="element-1694" data-mp="1yupc9iarlfrw" />
            </div>
            <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-1695" data-mp="2mj8og8wxqcp9">
              Transparent Reporting
            </h3>
            <p className="text-gray-700" data-id="element-1696" data-mp="2rhii2f30h58r">
              We publish comprehensive reports detailing our methodologies,
              findings, and recommendations, making complex scientific data
              accessible to all stakeholders.
            </p>
          </div>
        </div>
      </div>
    </section>;
};